import { LegalShell, LegalSection } from "./LegalShell";

const sections = [
  {
    h: "§ 1 Geltungsbereich",
    t: ["Diese AGB gelten für alle Verträge zwischen SA Webdesign und dem Auftraggeber über die Erstellung, Gestaltung, Pflege und Optimierung von Webseiten."],
  },
  {
    h: "§ 2 Leistungen",
    t: ["SA Webdesign erstellt individuelle Webseiten nach Absprache mit dem Kunden.", "Der genaue Leistungsumfang ergibt sich aus dem jeweiligen Angebot."],
  },
  {
    h: "§ 3 Vertragsschluss",
    t: ["Ein Vertrag kommt durch schriftliche Bestätigung des Angebots zustande."],
  },
  {
    h: "§ 4 Preise",
    t: ["Es gelten die im Angebot vereinbarten Preise.", "Alle Preise verstehen sich zuzüglich der gesetzlichen Umsatzsteuer, sofern diese erhoben wird."],
  },
  {
    h: "§ 5 Zahlung",
    t: ["Rechnungen sind innerhalb von 14 Tagen ohne Abzug zahlbar.", "SA Webdesign kann Abschlagszahlungen verlangen."],
  },
  {
    h: "§ 6 Mitwirkungspflichten",
    t: ["Der Kunde stellt alle benötigten Inhalte (Texte, Bilder, Logos usw.) rechtzeitig zur Verfügung.", "Verzögerungen aufgrund fehlender Mitwirkung verlängern vereinbarte Fertigstellungstermine entsprechend."],
  },
  {
    h: "§ 7 Urheberrecht",
    t: ["Bis zur vollständigen Bezahlung verbleiben sämtliche Nutzungsrechte bei SA Webdesign.", "Nach vollständiger Zahlung erhält der Kunde die vereinbarten Nutzungsrechte."],
  },
  {
    h: "§ 8 Haftung",
    t: ["SA Webdesign haftet nur für Vorsatz und grobe Fahrlässigkeit.", "Für Inhalte des Kunden übernimmt SA Webdesign keine Verantwortung."],
  },
  {
    h: "§ 9 Datenschutz",
    t: ["Es gelten die Bestimmungen der Datenschutzerklärung."],
  },
  {
    h: "§ 10 Schlussbestimmungen",
    t: ["Es gilt deutsches Recht.", "Sollte eine Bestimmung unwirksam sein, bleiben die übrigen Bestimmungen unberührt."],
  },
];

export default function Agb() {
  return (
    <LegalShell title="Allgemeine Geschäftsbedingungen">
      <p className="text-[15px] text-[#52525B] leading-relaxed mb-10">
        SA Webdesign · Inhaber: Stephan Appenzeller
      </p>
      {sections.map((s) => (
        <LegalSection key={s.h} heading={s.h}>
          {s.t.map((p) => (
            <p key={p}>{p}</p>
          ))}
        </LegalSection>
      ))}
    </LegalShell>
  );
}
